import { render, staticRenderFns } from "./lawsuit_case.vue?vue&type=template&id=6bb4470e&scoped=true"
import script from "./lawsuit_case.vue?vue&type=script&lang=js"
export * from "./lawsuit_case.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_case.vue?vue&type=style&index=0&id=6bb4470e&prod&scoped=true&lang=less"
import style1 from "./lawsuit_case.vue?vue&type=style&index=1&id=6bb4470e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4470e",
  null
  
)

export default component.exports